<template lang="pug">
.news-col.news-col--small
	template(v-if="isMobile")
		label#ccap-relationship-status-label.sr-only(for="news-theme-select-box-label") Topics
		VueSelect#news-theme-select-box.news-theme-select-box(label-id="news-theme-select-box-label", v-model="selectedTag")
			VueSelectOption(v-for="(newsTag, index) in newsTags", :text="newsTag", :key="index", :index="index", :value="newsTag", :label-id="`news-theme-select-box-${index}`")
	nav.news-theme.sf-card(v-if="!isMobile")
		h2.news-theme__title Topics
		p#news-theme__list-a11y.sr-only If you only want to see the news of a specific topic, select the topic you are interested in from the list below!
		ul.news-theme__list(aria-labelledby="news-theme__list-a11y")
			li.news-theme__list-item(v-for="(newsTag, index) in newsTags")
				a.news-theme__list-link(aria-labelledby="news-theme__list-text-hidden-a11y news-theme__list-text-a11y", :class="{ 'news-theme__list-link--active': selectedTag == newsTag }", @click.prevent="selectTag(newsTag)")
					span#news-theme__list-text-hidden-a11y.sr-only Current topic:
					span#news-theme__list-text-a11y.news-theme__list-text
						| {{ newsTag }}
						span.sr-only(aria-hidden="true") topic
</template>
<script>
import { defineComponent, ref } from '@vue/composition-api';
import { useNewsTags, useNewsStore } from '../composables/news-composable';
import { useIsMobile } from '../composables/is-mobile';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
export default defineComponent({
	components: {
		VueSelect,
		VueSelectOption
	},
	setup() {
		const { newsTags } = useNewsTags();
		const { isMobile } = useIsMobile();
		const { selectedTag, selectTag } = useNewsStore();
		return {
			newsTags,
			isMobile,
			selectedTag,
			selectTag
		};
	}
});
</script>
